/**
 * Strips HTML tags from an assessment description and removes the standard
 * "This assessment covers " prefix that the API prepends to all descriptions,
 * capitalising the remaining first character.
 */
export function stripHtml(html: string): string {
    const plain = html.replace(/<[^>]*>/g, '').trim();
    const prefix = 'This assessment covers ';
    if (plain.indexOf(prefix) === 0) {
        const rest = plain.slice(prefix.length);
        return rest.charAt(0).toUpperCase() + rest.slice(1);
    }
    return plain;
}
